import CashbacksList from './CashbacksList';

export default CashbacksList;
